import React from 'react';
import styles from '../../styles/RagIndicatorRisk.module.scss';
import { TooltipHost, TooltipOverflowMode } from '@fluentui/react/lib/Tooltip';

export interface IRagIndicatorForRiskProps {
    color?: string; // hex background color
    label?: string;
}

// Utility: decide whether text should be white or black based on luminance
const getContrastTextColor = (hexColor: string): string => {
    if (!hexColor) return '#000'; // fallback
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.6 ? '#000' : '#FFF'; // light bg -> black text, dark bg -> white text
};

export const RagIndicatorForRisk = ({ color, label }: IRagIndicatorForRiskProps): React.ReactElement => {
    const displayLabel = label || 'To be completed';
    const backgroundColor = color || '#B0B0B0'; // grey fallback
    //const textColor = getContrastTextColor(backgroundColor);
    const textColor = !color ? '#FFF' : getContrastTextColor(backgroundColor);
    const textShadow = !color ? '0 1px 2px rgba(0,0,0,0.6)' : 'none';

    return (
        <div className={styles.ragIndicator}>
            <div
                className={`${styles.fontSize14} ${styles.indicator}`}
                style={{
                    backgroundColor,
                    color: textColor,
                    textShadow: textShadow,
                }}
            >
                <TooltipHost
                    content={displayLabel}
                    overflowMode={TooltipOverflowMode.Parent}
                >
                    {displayLabel}
                </TooltipHost>
            </div>
        </div>
    );
};
